<template>
  <Mp3Title
    :title="title"
    :titFrom="titFrom"
    :navList="navList"
    @tabClassCode="tabClassCode"
    @bakToPrev="bakToPrev"
  >
    <template v-if="!$route.meta.keepAlive">
      <router-view :classcodeBranch="classcodeBranch"></router-view>
    </template>
    <template v-else>
      <router-view :classcodeBranch="classcodeBranch"></router-view>
    </template>
  </Mp3Title>
</template>
<script>
import Mp3Http from "./mp3";
import Mp3Title from "@/components/StudyCenter/Mp3Title";
export default {
  name: "review-home",
  data() {
    return {
      title: "MP3",
      classcodeBranch: "",
      titFrom: "",
      navList: [],
    };
  },
  components: {
    Mp3Title,
  },
  created() {
    this.student_id = this.$store.state.currentChild.student_id;
    this.getStuCode();
  },
  methods: {
    getStuCode() {
      Mp3Http.getStuCode({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        num: 2,
      }).then(({ data }) => {
        const { error, result } = data;
        if (error == 0) {
          this.titFrom = "main";
          this.navList = [].concat(result.list);
          this.classcodeBranch = result.list[0].classcode_branch;
        } else {
          this.titFrom = "";
          this.navList = [];
        }
      });
    },

    tabClassCode(v) {
      console.log(v);
      this.classcodeBranch = v;
    },

    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      console.log("bakToPrev");
      this.$router.go(-1);
    },
    getData() {
      console.log("getData");
    },
  },
};
</script>